import { useState, useCallback } from 'react';
import { adminToken } from '../../lib/api';
import { useAbortSignal } from '../../lib/hooks';
import {
  useNotify
} from 'react-admin';
import { useFormState } from 'react-final-form';

const usePurchase = () => {
  const { username } = useFormState().values;
  const [ type, setType ] = useState('');
  const [ token, setToken ] = useState('');
  const [ submitting, setSubmitting ] = useState(false);
  const signal = useAbortSignal();
  const notify = useNotify();

  const submit = useCallback(async () => {
    try {
      setSubmitting(true);
      const result = await adminToken(
        {
          username,
          type,
          token
        },
        signal
      );
      if (result.message) {
        notify(result.message);
      }
    }
    catch (err : any) {
      if (err.message) {
        notify(err.message, 'error');
      }
    }
    finally{
      setSubmitting(false);
    }
  }, [
    username,
    type,
    token,
    notify,
    signal
  ]);
  
  return {
    username,
    type,
    setType,
    token,
    setToken,
    submit,
    submitting
  };
};

export {
  usePurchase
};